const RFM_DB_NAME    = 'foxappy_rfm';
const RFM_DB_VERSION = 1;
const RFM_STORE      = 'rfm_kv';

function openRfmDB() {
  if (!('indexedDB' in window)) {
    return Promise.reject(new Error('IndexedDB não suportado'));
  }
  if (window._RFM_DB_PROMISE) return window._RFM_DB_PROMISE;

  window._RFM_DB_PROMISE = new Promise((resolve, reject) => {
    const req = indexedDB.open(RFM_DB_NAME, RFM_DB_VERSION);

    req.onupgradeneeded = (ev) => {
      const db = ev.target.result;
      if (!db.objectStoreNames.contains(RFM_STORE)) {
        db.createObjectStore(RFM_STORE);
      }
    };

    req.onsuccess = (ev) => resolve(ev.target.result);
    req.onerror   = (ev) => reject(ev.target.error);
  });

  return window._RFM_DB_PROMISE;
}

async function rfmCacheGet(key) {
  try {
    const db = await openRfmDB();
    return await new Promise((resolve, reject) => {
      const tx    = db.transaction(RFM_STORE, 'readonly');
      const store = tx.objectStore(RFM_STORE);
      const req   = store.get(key);

      req.onsuccess = () => resolve(req.result ?? null);
      req.onerror   = () => reject(req.error);
    });
  } catch (e) {
    console.warn('RFM IDB get error', e);
    return null;
  }
}

async function rfmCacheSet(key, value) {
  try {
    const db = await openRfmDB();
    return await new Promise((resolve, reject) => {
      const tx    = db.transaction(RFM_STORE, 'readwrite');
      const store = tx.objectStore(RFM_STORE);
      const req   = store.put(value, key);

      req.onsuccess = () => resolve(true);
      req.onerror   = () => reject(req.error);
    });
  } catch (e) {
    console.warn('RFM IDB set error', e);
  }
}

async function rfmCacheDel(key) {
  try {
    const db = await openRfmDB();
    return await new Promise((resolve, reject) => {
      const tx    = db.transaction(RFM_STORE, 'readwrite');
      const store = tx.objectStore(RFM_STORE);
      const req   = store.delete(key);

      req.onsuccess = () => resolve(true);
      req.onerror   = () => reject(req.error);
    });
  } catch (e) {
    console.warn('RFM IDB del error', e);
  }
}
